<template>
  <div
    class="loading"
    v-if="loading"
  >
    <div class="loading-svg-container">
      <div class="loading-svg"></div>
      <span class="tip">数据加载中</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(['loading'])
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.7);

  .loading-svg-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .loading-svg {
      width: 50px;
      height: 50px;
      background-image: url('../assets/images/loading.svg');
      background-repeat: no-repeat;
      background-size: cover;
    }
    .tip {
      font-size: 14px;
      color: #07c160;
    }
  }
}
</style>
